import { MedicationFrequencyEnum } from "requests";

export const FREQUENCY_OPTIONS = [
  { value: MedicationFrequencyEnum.Prn, label: "PRN" },
  { value: MedicationFrequencyEnum.Hr_2, label: "2 hrs" },
  { value: MedicationFrequencyEnum.Hr_4, label: "4 hrs" },
  { value: MedicationFrequencyEnum.Hr_6, label: "6 hrs" },
  { value: MedicationFrequencyEnum.Hr_8, label: "8 hrs" },
  { value: MedicationFrequencyEnum.Hr_10, label: "10 hrs" },
  { value: MedicationFrequencyEnum.Hr_12, label: "12 hrs" },
  { value: MedicationFrequencyEnum.Hr_14, label: "14 hrs" },
  { value: MedicationFrequencyEnum.Hr_16, label: "16 hrs" },
  { value: MedicationFrequencyEnum.Hr_18, label: "18 hrs" },
  { value: MedicationFrequencyEnum.Hr_20, label: "20 hrs" },
  { value: MedicationFrequencyEnum.Hr_22, label: "22 hrs" },
  { value: MedicationFrequencyEnum.Hr_24, label: "24 hrs" }
];
